import { AxiosProgressEvent, AxiosRequestConfig } from 'axios';

export type OnUploadProgressFn = (percent: number) => void;

export type ServiceUploadingOptions = {
  onUploadProgress?: OnUploadProgressFn;
};

export const toAxiosUploadConfig = (
  options: ServiceUploadingOptions,
): AxiosRequestConfig => {
  if (!options.onUploadProgress) return {};

  return {
    onUploadProgress: (event: AxiosProgressEvent) => {
      if (!event.total) return;
      const percent = Math.round((event.loaded / event.total) * 100);
      options.onUploadProgress?.(percent);
    },
  };
};
